import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram, ExternalLink } from "lucide-react";
import { api, API } from "../lib/api";
import { INSTAGRAM, INSTAGRAM_URL } from "../lib/content";

export default function MovementFeed() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/feed").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="mt-10" data-testid="movement-feed">
      <p className="mono-label text-[#C2410C] mb-4">Latest from the movement</p>
      {posts.length === 0 ? (
        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer"
          className="flex items-center gap-4 bg-white border border-[#E2DCD2] hover:border-[#1E4B3E] rounded-2xl p-6 transition-colors" data-testid="feed-follow-cta">
          <Instagram size={22} className="text-[#C2410C]" />
          <span className="text-sm text-[#52525B]">Fresh posts from the community land here — follow <strong className="text-[#1A1A1A]">{INSTAGRAM}</strong> in the meantime.</span>
        </a>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {posts.map((p, i) => (
            <motion.a key={p.id} href={p.link || INSTAGRAM_URL} target="_blank" rel="noreferrer"
              data-testid={`feed-post-${i + 1}`}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="group relative rounded-2xl overflow-hidden border border-[#E2DCD2] bg-black aspect-square block">
              <img src={`${API}/feed/image/${p.id}`} alt={p.caption || "Movement post"} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              {p.caption && <p className="absolute bottom-3 left-3 right-3 text-white text-xs leading-snug line-clamp-2">{p.caption}</p>}
              <ExternalLink size={14} className="absolute top-3 right-3 text-white/70" />
            </motion.a>
          ))}
        </div>
      )}
    </div>
  );
}
